import * as THREE from "three"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js"
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js"
// import DRACOLoader from 'three-dracoloader';

import ModelBase from "./model_base";
import gsap from "gsap"

export class Chair extends ModelBase {
    constructor(parent, initModel, simulator) {
        super(parent);

        if(typeof initModel === 'undefined') initModel = false;
        if(typeof simulator === 'undefined') simulator = null;

        this._name = 'Chair';

        this._parent_bound_position = null;

        this._info = null;
        this._simulator = simulator;
        
        this._init(initModel)
    }

    change(changeModel) {
        const oldModelInfo = this._info;
        this._simulator._onModelChangeBefore(oldModelInfo)

        this.loadModel(changeModel, () => {
            if(this._parent) {
                this._parent._reposChairsAll();

                this._simulator._onModelChange(oldModelInfo, this)
            }
        });
    }

    delete(newObject = false) {
        if(this._parent) this._parent.removeChair(this, newObject ? newObject : null, false);

        super.delete();
    }

    // 사이즈 중 깊이(z)를 리턴
    getDepthSize() {
        const objectBound = new THREE.Box3().setFromObject(this._model)
        const chairSize = objectBound.getSize(new THREE.Vector3());

        return chairSize.x;
    }

    saveBoundPosition() {
        this._parent_bound_position_save = this._parent_bound_position;
    }

    setBoundPosition(position) {
        this.trigger('changeBoundPosition', {old: this._parent_bound_position, new: position});

        this._parent_bound_position = position;
        this._rotationAtTable();
    }

    getSaveBoundPosition() {
        return this._parent_bound_position_save;
    }

    getBoundPosition() {
        return this._parent_bound_position;
    }

    // ------------------------------------------------
    // 위치 설정
    // setPosition({x:10, y:10});
    // setPosition({x:10});

    setPosition(position) {
        position = Object.assign({x: this._model.x,y: this._model.y,z: this._model.z}, position);
        this._model.position.set(position.x, position.y, position.z);

        this._rotationAtTable();

        // this._model.lookAt(this._parent.getPosition()) // 원형으로 돌아보기
    }

    __checkModelInfo(info) {
        if(info && info.filename) return true;
        return false;
    }

    loadModel(info, onLoad) {
        if(typeof(onLoad) === 'undefined') onLoad = null;

        if(typeof(info) === 'string') {
            this.loadModelFromJSON(info, onLoad);
        } else {
            if (this.__checkModelInfo(info)) {
                this._info = info;

                
                const gltfLoader = new GLTFLoader(this._simulator._manager);
                const dracoLoader = new DRACOLoader(this._simulator._manager);
                dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.6/');
                gltfLoader.setDRACOLoader(dracoLoader);

                gltfLoader.load(info.filename, (gltf) => {
                    const obj3d = gltf.scene
                    obj3d.name = info.name
                    
                    let initPosition = false;
                    
                    if(this._model) {
                        initPosition = this._model.position;
                        this.delete(obj3d);
                    }

                    if(info.size) {
                        this.setSize(info.size);
                    } else {
                        this.setSize(null)
                    }

                    this._model = obj3d;
                    this._model.__parent = this;

                    // obj3d.castShadow = true
                    // obj3d.receiveShadow = true

                    obj3d.traverse((child) => {
                        if(child.isMesh) 
                        {
                            child.castShadow = true
                            child.receiveShadow = true
                            // if(child.material) child.material.map.anisotropy = 16;

                            if (child instanceof THREE.Mesh &&
                            child.material instanceof THREE.MeshStandardMaterial) 
                            {
                                if(child.material.metalness > 0) child.material.envMap = this._simulator._scene._environment;
                            }   
                        }       
                    })

                    if(initPosition) {
                        initPosition.y = 0;
                        this._model.position.copy(initPosition);
                    }

                    if(onLoad) {
                        onLoad();
                    }
                    
                    this.trigger('loadModel')
                    this._simulator._onModelLoadSingle(this)
                },
                ( xhr ) => {
                    let percent = Math.round(xhr.loaded / xhr.total * 100 );
                    this._simulator._onModelLoadSinglePrgress(this, percent);
                })
            }
        }
    }

    loadModelFromJSON(filename, onLoad) {
        fetch("./json/chair/" + filename)
            .then((response) => {
                return response.json()
            })
            .then((json) => {
                this.loadModel(json, onLoad);
            });

    }

    _init(initModel) {
        if(initModel) {
            this._model = null;

            this.loadModel(initModel);
        } else {
            this._geometry = new THREE.BoxGeometry(0.49, 0.79, 0.41)
            this._material = new THREE.MeshNormalMaterial({
                color: 0x000000,
            })

            this._model = new THREE.Mesh(this._geometry, this._material)
            this._model.__parent = this;
            this._model.castShadow = true
        }
    }

    _rotationAtTable() {
        switch(this._parent_bound_position) {
            case 'left':
                this._model.rotation.y = Math.PI / 2;
                // gsap.killTweensOf(this._model.rotation, 'y').to(this._model.rotation, {duration:0.3, y:Math.PI / 2})
                break;
            case 'right':
                this._model.rotation.y = - Math.PI / 2;
                // gsap.killTweensOf(this._model.rotation, 'y').to(this._model.rotation, {duration:0.3, y:Math.PI + Math.PI / 2})
                break;
            case 'top':
                this._model.rotation.y = 0;
                // gsap.killTweensOf(this._model.rotation, 'y').to(this._model.rotation, {duration:0.3, y:0})
                break;
            case 'bottom':
                this._model.rotation.y = Math.PI;
                // gsap.killTweensOf(this._model.rotation, 'y').to(this._model.rotation, {duration:0.3, y:Math.PI})
                break;
        }
    }
}